import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo, useEffect } from 'react';
import { Button, Badge, Tooltip } from 'antd';
import { useContext } from 'use-context-selector';
import styled, { cx, css } from '../../../styled';
import { useMediaQueryDown } from '../../../ThemeProvider/mediaQuery/useMediaQuery';
import TopbarActionsContext from '../Actions/context';
const Action = forwardRef((_a, ref) => {
    var { active, icon, label, onClick, className, tooltip, badgeCount, badgeDot } = _a, rest = __rest(_a, ["active", "icon", "label", "onClick", "className", "tooltip", "badgeCount", "badgeDot"]);
    const registerAction = useContext(TopbarActionsContext);
    const hideLabel = useMediaQueryDown('md');
    label = hideLabel ? undefined : label;
    useEffect(() => {
        const unregister = registerAction({ badgeCount: badgeCount !== null && badgeCount !== void 0 ? badgeCount : 0, badgeDot: badgeDot !== null && badgeDot !== void 0 ? badgeDot : false });
        return () => unregister();
    }, [badgeCount, badgeDot, registerAction]);
    return (_jsx("div", Object.assign({ className: cx(className, { '--hst-active': active }), onClick: onClick }, rest, { ref: ref }, { children: _jsx(Tooltip, Object.assign({ title: tooltip }, { children: _jsx(Badge, Object.assign({ count: badgeCount === 0 ? undefined : badgeCount, dot: badgeCount ? false : badgeDot, offset: [-4, 8] }, { children: _jsx(Button, Object.assign({ shape: !label ? 'circle' : 'round', icon: icon, type: 'text' }, { children: label })) })) })) })));
});
export default styled(memo(Action), { label: 'hst-topbar-action' })(({ theme }) => css `
    & .anticon {
      font-size: 20px;
      vertical-align: text-bottom;
    }

    button {
      color: ${theme.antd.colorText};
      margin-top: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &.--hst-active button {
      background-color: ${theme.antd.colorBgTextHover};
    }
  `);
